const TwoFactorAuthenticate = {
    SMS: 4,
    EMAIL: 5,
}
export default TwoFactorAuthenticate;
